import { render, staticRenderFns } from "./ServiceSpecificatiosTable.vue?vue&type=template&id=78de04cc&"
import script from "./ServiceSpecificatiosTable.vue?vue&type=script&lang=js&"
export * from "./ServiceSpecificatiosTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSpecificatiosTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports